import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  reportsDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './board-approve-dialog.controller';
import template from './board-approve-dialog.html';
import messageTpl from '../messages/assessment.analysis-date.messages.html';

class dialogService {
  getOptions($event, {
    assessmentId,
    assessmentName,
    includePandemicPolicy,
    includeEmergencyPlan,
    includeKeyContacts,
    includeSchematics,
    isNavantaUser,
    users
  }) {
    return {
      controller,
      controllerAs: 'boardApproveDialogVM',
      locals: {
        assessmentId,
        assessmentName,
        includePandemicPolicy,
        includeEmergencyPlan,
        includeKeyContacts,
        includeSchematics,
        isNavantaUser,
        users
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.boardApproveDialog', [
  alerts,
  bcpDataService,
  constants,
  ssDialogService,
  loaderService,
  reportsDataService,
])
  .service('bcpBoardApproveDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('assessment.analysis-date.messages.html', messageTpl);
  })
  .name;
